import "../styles/carousel.scss";
import React, { useEffect, useState } from "react";
import Carousel from "./Carousel";
import ProjectSummary from "./ProjectSummary";
import { projects } from "../constants/constants";
import { useDispatch, useSelector } from "react-redux";
import { MyProjects } from "../constants/constants";

const Projects = (props) => {

    //Defining image folder name inside public folder
    const imageFolder = "projects"/*props.imageFolder;*/

    //Setting up a hook on current language
    const storeCurrentLanguage = state => state.language;
    const currentLanguage = useSelector(storeCurrentLanguage);

    const dispatch = useDispatch();

    const storeCurrentProject = state => state.carouselCurrentProject;
    const currentProject = useSelector(storeCurrentProject)

    const storeCurrentImage = state => state.carouselCurrentImage;
    const currentImage = useSelector(storeCurrentImage)

    const storeNumberOfImages = state => state.carouselNbOfImages;
    const numberOfImages = useSelector (storeNumberOfImages);

    
    
    /*What Happens after the component renders*/
    useEffect(() => {

    /*We give the right css classes to the images so the result on screen matches the direction clicked*/

    }, [currentProject]);

    let nextProject = null
    if (currentProject === projects.length - 1) {
        nextProject = 0 
    } else {
        nextProject = currentProject + 1
    }

    console.log("nextProjectIndex "+nextProject)

    return (
    <div className = 'projects'>
        <div className =  'projects__title'>{MyProjects[currentLanguage]}</div>
        <ProjectSummary projectIndex = {currentProject}/>

        <Carousel initialPage = {currentImage} projectIndex = {currentProject} nbOfImages = {numberOfImages}/>
    </div>
    )
    
}

export default Projects









/*import '../styles/projects.scss'
import { useState } from 'react'
import { projects } from '../constants/constants'
import { useEffect } from 'react'

const Projects = () => {

        

        const [currentImage, setCurrentImage] = useState("/images/"+projects[currentProject].image+".png")

    useEffect( () => {
         setCurrentImage("/images/"+projects[currentProject].image+".png")
    }, [currentProject])



    const navigateProjects = (increment) => {
        if (currentProject + increment === projects.length) {
            setCurrentProject(0)
        }
        else if (currentProject + increment === - 1) {
            setCurrentProject(projects.length - 1)
        }
        else {
            setCurrentProject(currentProject + increment)
        }
    }

    return <div className = 'projects'>
        
        <button className = 'projects__nav' onClick = {(e)=> {
            console.log("going left")
            navigateProjects(-1)
        }}>Go left</button>

            <img src = {currentImage} className = 'projects__project-container' ></img>
        
        <button className = 'projects__nav'  onClick = {(e)=> {
            navigateProjects(1)
        }}>Go right</button>
        
    </div>
}
export default Projects*/